"use client";
import React, { useState } from "react";
import { consultationRequestBtnStyle } from "../bookingStyles";

/**
 * Consultation request button shown in member panels when the selected
 * services require a consultation. Shows "Send a request" text with
 * hover/press feedback.
 */
export function ConsultationButton({ onClick }: { onClick: () => void }) {
  const [hovered, setHovered] = useState(false);
  const [pressed, setPressed] = useState(false);

  return (
    <div
      role="button"
      tabIndex={0}
      style={{
        ...consultationRequestBtnStyle,
        filter: pressed
          ? "brightness(0.9)"
          : hovered
            ? "brightness(1.15)"
            : undefined,
      }}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
        setPressed(false);
      }}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
    >
      Send a request
    </div>
  );
}
